import OposService from "@/services/opos.service";

const state = {
  selectedRange: null,
  vat_rate: 19, //TODO ? usunać?
  search: {
    owners: [],
    company: [],
    status: ['not_started', 'in_progress', 'not_payment', 'finished'],
    range_date: null,
  },
  opos: null,
};

const getters = {
  search: state => {
    return state.search;
  },
  items: state => {
    return state.opos;
  },
  selectedRange: state => {
    return state.selectedRange;
  },
};

const actions = {
  async doSearch({
    commit,
    state
  }) {
    let items = await OposService.search(state.search);
    // Podliczanie cen netto
    for (let index = 0; index < items.length; index++) {
      const element = items[index];
      items[index].offer_price = element.offer_price;
      items[index].cost_materials = element.cost_materials;
      items[index].cost_subcontractors = element.cost_subcontractors;
      items[index].profit = element.offer_price - (element.cost_materials + element.cost_subcontractors);
      items[index].profitpercentage = (element.offer_price === 0) ? 0 : ((items[index].profit / element.offer_price) * 100.0);
    }
    commit("items", items);
  },
};

const mutations = {
  range(state, {
    selected,
    range
  }) {
    state.selectedRange = selected;
    state.search.range_date = range;
  },
  owners(state, meangerPayLoad) {
    state.search.owners = meangerPayLoad;
  },
  status(state, statusPayLoad) {
    state.search.status = statusPayLoad;
  },
  company(state, companyPayLoad) {
    state.search.company = companyPayLoad;
  },
  items(state, payload) {
    state.opos = payload;
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};